/**
 * 親テーマ common.js の product sticky 高さ計算を上書きする。
 * - 短いコンテンツで 91.5vh 連動の負マージンが次セクションを被せないようにする
 * - ノートPCなど縦が短い画面でも「長文 sticky」誤判定しない
 */
export default class ProductStickyHeight {
  constructor() {
    this.items = document.querySelectorAll('.ol-product__content-item');
    if (!this.items.length) return;

    this.mq = window.matchMedia('(min-width: 841px)');
    this.resizeTimer = null;
    this.update = this.update.bind(this);
    this.onResize = this.onResize.bind(this);

    const run = () => requestAnimationFrame(() => requestAnimationFrame(this.update));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    // 親 common.js の DOMContentLoaded より後にもう一度上書き
    window.addEventListener('load', this.update);
    window.setTimeout(this.update, 0);
    window.addEventListener('resize', this.onResize);
  }

  onResize() {
    window.clearTimeout(this.resizeTimer);
    this.resizeTimer = window.setTimeout(this.update, 150);
  }

  resetItem(content, wrapper) {
    if (content) {
      content.style.marginBottom = '';
      content.style.paddingBottom = '';
      content.style.top = '';
    }
    if (wrapper) {
      wrapper.style.height = '';
    }
  }

  update() {
    this.items.forEach((item) => {
      const content = item.querySelector('.ol-product__content');
      const wrapper = item.querySelector('.ol-product__image-sticky-wrapper');
      if (!content || !wrapper) return;

      if (!this.mq.matches) {
        this.resetItem(content, wrapper);
        return;
      }

      // 親 JS の余白をいったん外して実寸を測る
      content.style.marginBottom = '0';
      content.style.paddingBottom = '0';
      content.style.top = '';

      const contentHeight = content.offsetHeight;
      const windowHeight = window.innerHeight;
      const img = item.querySelector(
        '.ol-product__mainimage img, .ol-product__mainimage .ol-product-image1-shortcut'
      );
      const imgHeight = img ? img.offsetHeight : 0;

      // テキストが画像と同程度／ビューポートより短い → 負マージンで次セクションを引き上げない
      // （画像が vh より高いだけで長文扱いにしない）
      const isShortContent =
        !imgHeight ||
        contentHeight <= imgHeight + 8 ||
        contentHeight < windowHeight;

      if (isShortContent) {
        wrapper.style.height = `${Math.max(contentHeight, imgHeight)}px`;
        content.style.marginBottom = '0';
        content.style.paddingBottom = '0';
        return;
      }

      // 長いコンテンツ: sticky 用に親と同系の計算を維持
      content.style.marginBottom = `calc(-1 * (${contentHeight}px - 91.5vh + 1.8em))`;
      content.style.top = `calc(-1 * (${contentHeight}px - 91.5vh + 1.8em))`;
      content.style.paddingBottom = '';
      wrapper.style.height = `calc(${contentHeight}px + 3.96em)`;
    });
  }
}
